import { render, staticRenderFns } from "./QualityAssuranceLabelUpload.vue?vue&type=template&id=2622be25"
import script from "./QualityAssuranceLabelUpload.vue?vue&type=script&lang=js"
export * from "./QualityAssuranceLabelUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports